import React from 'react';
import { Database, Scale, Server, Lightbulb } from 'lucide-react';
import { technologyFeatures, images } from '../data/mock';

const iconMap = {
  Database: Database,
  Scale: Scale,
  Server: Server,
  Lightbulb: Lightbulb,
};

const TechnologySection = () => {
  return (
    <section id="technology" className="py-24 md:py-32 bg-slate-900 relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={images.technology}
          alt=""
          className="w-full h-full object-cover opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/95 to-slate-900" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <span className="inline-block text-cyan-400 text-sm font-semibold tracking-wider uppercase mb-4">
            Technology & Innovation
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
            Systems We Build,<br />Standards We Follow
          </h2>
          <p className="text-lg text-slate-400 leading-relaxed">
            Our technology foundation is built on principles of security, scalability, and continuous improvement.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {technologyFeatures.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            const isEven = index % 2 === 0;
            
            return (
              <div
                key={feature.id}
                className={`group flex items-start space-x-5 p-6 rounded-2xl border border-slate-800 bg-slate-900/50 backdrop-blur-sm hover:border-cyan-500/30 transition-all duration-300 ${
                  isEven ? 'md:translate-x-4' : 'md:-translate-x-4'
                }`}
              >
                {/* Icon */}
                <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-gradient-to-br from-cyan-500/20 to-teal-500/10 flex items-center justify-center text-cyan-400 group-hover:from-cyan-500/30 group-hover:to-teal-500/20 transition-all duration-300">
                  <Icon size={28} />
                </div>

                {/* Content */}
                <div>
                  <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-cyan-50 transition-colors">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-slate-400 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TechnologySection;
